import { Fragment } from "react";
import { coreBlocks } from "./coreBlocks";
import { jltBlocks } from "./jltBlocks";
import { masterBlocks } from "./masterBlocks";

const gutenbergBlocks = {
  ...coreBlocks,
  ...jltBlocks,
  ...masterBlocks,
};

export const BlockRenderer = ({ blocks }) => {
  return blocks?.map((block, i) => {
    const renderBlock = gutenbergBlocks?.[block?.name];
    const key = block?.clientId ?? block?.id ?? `${block?.name}-${i}`;

    if (typeof renderBlock === "function") {
      return <Fragment key={key}>{renderBlock(block)}</Fragment>;
    }

    console.warn(`No renderer for block: ${block?.name}`);
    return null;
  });
};
